import React from "react"
import classNames from "classnames"
import Icon from "../Icon/Icon"
import {IcomoonIconName} from "../Icon/icons"

interface Props {
	type: "is-warning" | "is-danger" | "is-info" | "is-security-info"
	message?: string | React.ReactNode
	title?: string
	icon?: IcomoonIconName
	iconHasSemanticColor?: boolean
	isFullWidth?: boolean
	className?: string
}

export default function Admonition({
	type,
	message,
	title = "",
	icon = "alert-circle--interface-essential",
	className,
	iconHasSemanticColor = false,
	isFullWidth = false,
}: Props) {
	return (
		<article className={classNames("admonition", type, className, isFullWidth && "is-full-width")}>
			<div className="message-body admonition-message-body">
				<div className={"admonition-message-body-icon"}>
					<Icon
						icon={icon}
						size={16}
						className={classNames("admonition-icon", iconHasSemanticColor && "has-semantic-color")}
					/>
				</div>
				<div className={"admonition-texts"}>
					{title && <h3 className="admonition-message-body-title">{title}</h3>}
					{message && <div className="admonition-message-body-container">{message}</div>}
				</div>
			</div>
		</article>
	)
}
